import productService from '@/services/product';
import orderService from '@/services/order';
import storageService from '@/services/storage';
import moment from 'moment';
import store from '@/store';
import Icon from 'vue-awesome';
import customerService from '@/services/customer';
import { encodePathSegment } from '@/utils/url';

const getImageUrl = hash =>
  `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/download/${encodePathSegment(hash)}?access_token=${encodeURIComponent(
    store.state.auth.token,
  )}`;

const getUploadUrl = () =>
  `${process.env.API_LOCATION}api/Containers/${process.env.GS_BUCKET}/upload`;

export default {
  components: {
    wordboard: require('@/components/wordboard/wordboard.vue'),
    addressSelector: require('@/components/addressSelector/addressSelector.vue'),
    Icon,
  },
  data() {
    return {
      customerTimer: null,
      productTimer: null,
      products: [],
      productLoading: false,
      imgDialog: false,
      imageActionURL: getUploadUrl(),
      dialogImgUrl: '',
      addresses: [],
      extraDialogVisible: false,
      curExtra: '',
      curIdx: 0,
      formData: false,
    };
  },
  props: ['form', 'fileList'],
  computed: {
    imageHeaders() {
      return {
        Authorization: store.state.auth.token,
      };
    },
  },
  mounted() {
    this.fetchCount();
  },
  watch: {
    'form.items': {
      handler: (items) => {
        items.forEach((o) => {
          o.totalPrice = o.quantity * o.price;
        });
      },
      deep: true,
    },
    form: {
      handler(item) {
        const discountPercent = item.discount > 0 ? item.discount * 0.01 : 0;
        let total = 0;
        item.items.forEach((o) => {
          total += o.totalPrice;
        });

        let totalDiscount = 0;
        item.items.filter(o => o.discountable).forEach((o) => {
          totalDiscount += o.totalPrice * discountPercent;
        });

        if (!item.bypassTax) {
          item.tax = ((parseFloat(total) - parseFloat(totalDiscount)) + parseFloat(item.setupPrice) + parseFloat(item.deliveryPrice)) * 0.07;
        } else {
          item.tax = 0;
        }

        item.totalDiscount = totalDiscount;
        item.totalPrice =
          parseFloat(total) +
          parseFloat(item.tax) +
          parseFloat(item.deliveryPrice) +
          parseFloat(item.setupPrice) -
          parseFloat(totalDiscount);
      },
      deep: true,
    },
  },
  methods: {
    async fetchCount() {
      try {
        const count = await orderService.get({
          filter: {
            order: 'id DESC',
            limit: 1,
          },
        });
        this.count = count.data[0].id;
        this.setOrderNum(this.count);
      } catch (e) {
        console.error(e);
      }
    },
    async setOrderNum(count) {
      return (this.form.orderNum = `O-${moment().format('YYMM')}-${count + 1}`);
    },
    async productSearch(queryString) {
      clearTimeout(this.productTimer);
      this.productLoading = true;
      this.productTimer = setTimeout(async() => {
        const rawProducts = await productService.get({
          filter: {
            where: {
              refCode: {
                like: `${queryString}%`,
              },
            },
          },
        });

        const products = rawProducts.data.map(o => ({
          value: o.refCode,
          ...o,
        }));

        this.products = products;
        this.productLoading = false;
      }, 300);
    },
    createFilter(queryString) {
      return data => data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    },
    async customerSearch(queryString, cb) {
      clearTimeout(this.customerTimer);
      this.customerTimer = setTimeout(async() => {
        customerService.get({
            filter: {
              where: {
                name: {
                  like: `${queryString}%`,
                },
              },
              include: ['addresses'],
            },
          },
          (err, rawCustomers) => {
            const customers = rawCustomers.data.map(o => ({
              value: o.name,
              ...o,
            }));

            cb(customers);
          },
        );
      }, 300);
    },
    handleProductSelect(index) {
      const currentObj = this.form.items[index];
      const theProduct = this.products.find(o => o.refCode === currentObj.refCode);

      if (theProduct) {
        currentObj.name = theProduct.name;
        currentObj.price = theProduct.price;
        currentObj.title = theProduct.title;
        currentObj.discountable = theProduct.discountable;
        currentObj.description = theProduct.description;
        currentObj.id = theProduct.id;
        currentObj.category = theProduct.category;
      }
    },
    handleDeliveryTypeSelect(item) {
      if (item === 'pickUp') {
        this.form.deliveryPrice = 0;
      }
    },
    handleCustomerSelect(item) {
      this.form.customerId = item.id;
      this.form.customerPhoneNumber = item.phoneNumber;
      this.form.customerLineId = item.lineId;
      this.addresses = item.addresses;
      if (!item.addresses) {
        this.addresses = [];
      }
    },
    resetCustomer() {
      this.form.customerId = '';
      this.form.customerName = '';
      this.form.customerLineId = '';
      this.addresses = [];
    },
    addOrderItem() {
      this.form.items.push({
        refCode: '',
        name: '',
        quantity: 1,
        price: '',
        discount: '',
        totalPrice: '',
      });
    },
    addToAddress(value) {
      this.form.deliveryAddress += value;
    },
    replaceAddress(address) {
      this.form.deliveryAddress = `${address.address} ${address.subDistrict} ${address.district} ${address.province} ${address.zipCode} ${address.country}`;
    },
    moveUp(idx) {
      this.form.items.splice(idx - 1, 0, this.form.items.splice(idx, 1)[0]);
    },
    moveDown(idx) {
      this.form.items.splice(idx + 1, 0, this.form.items.splice(idx, 1)[0]);
    },
    removeItem(idx) {
      this.form.items.splice(idx, 1);
    },
    handleRemove(file) {
      this.form.images = this.form.images.filter(img => img !== file.filename);
      storageService.del(file.filename);
    },
    handlePictureCardPreview(file) {
      this.imgDialog = true;
      this.dialogImgUrl = file.url;
    },
    handleImageUploaded(response) {
      this.form.images.push(response.result.files.file[0].name);
    },
    openExtraEdit(idx) {
      this.curExtra = this.form.items[idx].description;
      this.extraDialogVisible = true;
      this.curIdx = idx;
    },
    handleClose(done) {
      this.extraDialogVisible = false;
      done();
    },
    setExtra() {
      this.form.items[this.curIdx].description = this.curExtra;
      this.extraDialogVisible = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/orderForm/orderForm.js